import { motion } from "framer-motion";
import { FaMapMarkerAlt } from "react-icons/fa";
import { projects } from "../../data/projects";

const ProjectsGrid = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Portfolio
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Our Featured <span className="text-[#F59E0B]">Projects</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{
                opacity: 0,
                y: 30,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:-translate-y-2 transition-all duration-300"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="h-72 w-full object-cover group-hover:scale-110 transition duration-700"
                />
                <div className="absolute top-4 left-4 bg-[#F59E0B] text-white px-4 py-1 rounded-full text-sm font-semibold">
                  {project.category}
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-[#082B57] mb-3 group-hover:text-[#F59E0B] transition">
                  {project.title}
                </h3>

                <div className="flex items-center gap-2 text-gray-500 mb-6">
                  <FaMapMarkerAlt className="text-[#F59E0B]" />
                  <span>{project.location}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsGrid;
